import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { doLogin, updateSession } from "../redux/actions/Session";
import { Form, Input, Button, Icon, message } from 'antd'
import { stylesLogin } from '../styles/styles'
import { post } from "../lib/api";

class CreateUser extends Component {
    state = {
        user: "",
        password: "",
        name: ""
    }

    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    async handleSubmit(e) {
        e.preventDefault();
        if (this.state.user === "" || this.state.password === "" || this.state.name === "") {
            message.warning("Por favor llene todos los campos")
        } else {
            this.addUser()
            message.success("Usuario creado")
        }
    }

    async addUser() {
        var new_user = {
            email: this.state.user,
            emailVerified: false,
            password: this.state.password,
            displayName: this.state.name,
            disabled: false
        }
        await post("createUser", { user: new_user });
    }

    render() {
        return (
            <div className="mainDiv" style={stylesLogin.mainDiv}>
                <Form layout="vertical" onSubmit={this.handleSubmit} style={stylesLogin.form}>
                    <Form.Item>
                        <Input
                            prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
                            placeholder="Nombre"
                            value={this.state.name}
                            onChange={event => this.setState({ name: event.target.value })}
                        />
                    </Form.Item>
                    <Form.Item>
                        <Input
                            prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
                            placeholder="Email"
                            value={this.state.user}
                            onChange={event => this.setState({ user: event.target.value })}
                        />
                    </Form.Item>
                    <Form.Item>
                        <Input
                            prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
                            type="password"
                            placeholder="Password"
                            value={this.state.password}
                            onChange={event => this.setState({ password: event.target.value })}
                        />
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" htmlType="submit" className="loginButton" style={stylesLogin.button}>
                            Añadir
                    </Button>
                    </Form.Item>
                </Form>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return { session: state.session.user, firebase: state.firebase.app }
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({ doLogin, updateSession }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateUser);